var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Driver Payouts"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('Load')]},proxy:true}])},[_c('List'),_c('Summary',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }